export function getServerHeaderTriggerProps(expanded: boolean) {
  return {
    role: "button" as const,
    hasPopup: "menu" as const,
    expanded,
  };
}
